import Select from "react-select";

interface RejectionReasonModalProps {
  isOpen: boolean;
  selectedReason: any;
  onChange: (val: any) => void;
  onClose: () => void;
  onConfirm: () => void;
  options: { label: string; value: string }[];
  styles: any;
}

const RejectionReasonModal: React.FC<RejectionReasonModalProps> = ({
  isOpen,
  selectedReason,
  onChange,
  onClose,
  onConfirm,
  options,
  styles,
}) => {
  if (!isOpen) return null;

  return (
    <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/30">
      <div className="bg-white w-[400px] rounded-xl p-6 space-y-4">
        <h3 className="text-lg font-semibold">Reject Media</h3>

        <Select
          value={selectedReason}
          onChange={onChange}
          options={options}
          styles={styles}
          placeholder="Select rejection reason"
        />

        <div className="flex gap-3 pt-2">
          <button className="flex-1 py-2 rounded-lg border" onClick={onClose}>
            Cancel
          </button>

          <button
            className="flex-1 py-2 rounded-lg bg-red-600 text-white disabled:opacity-50"
            disabled={!selectedReason}
            onClick={onConfirm}
          >
            Confirm Rejection
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectionReasonModal;
